export const ModThingTypeMrn = "mrn:sl2:::mod";
